module.exports = __webpack_public_path__ + "img/phone-transparent-3-layer.0b07584f.png";